import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import PropertyRow from 'app/shared/components/soh/PropertyRow';

import { AppSelectors, UserSelectors } from 'app/shared/selectors';

import {
    Text,
    Spacer,
} from '@zillow/constellation';

import {
    StyledHeaderContainer,
    StyledPropertyCol,
} from './StyledComponents';

function PropertiesViewList(props) {
    const renderHeader = () => (
        <StyledHeaderContainer>
            <StyledPropertyCol xs={2} />
            <StyledPropertyCol xs={3}><Text fontType="label" as="label">Status</Text></StyledPropertyCol>
            <StyledPropertyCol xs={1}><Text fontType="label" as="label">City</Text></StyledPropertyCol>
            <StyledPropertyCol xs={1}><Text fontType="label" as="label">State</Text></StyledPropertyCol>
            <StyledPropertyCol xs={1}><Text fontType="label" as="label">Source</Text></StyledPropertyCol>
            <StyledPropertyCol xs={2}><Text fontType="label" as="label">Advertising</Text></StyledPropertyCol>
            <StyledPropertyCol xs={1}><Text fontType="label" as="label">Boost</Text></StyledPropertyCol>
            <StyledPropertyCol xs={1} />
        </StyledHeaderContainer>
    );
    return (
        <Spacer paddingBottom="md">
            {renderHeader()}
            {props.listings.map((listing, index) => (
                <PropertyRow
                    key={index}
                    listing={listing}
                />
            ))}
        </Spacer>
    );
}

PropertiesViewList.propTypes = {
    listings: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
    user: UserSelectors.makeUser(state),
    cookieEnabledServices: AppSelectors.makeCookieEnabledServices(state),
});

export { PropertiesViewList };
export default connect(mapStateToProps)(PropertiesViewList);
